import React from 'react';
import { InputSection, Label, Input, Message } from './style';

const PasswordInputSection = ({
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    passwordMessage,
    setPasswordMessage,
    confirmPasswordMessage,
    setConfirmPasswordMessage,
}) => {
    // 비밀번호 입력 변경 핸들러
    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);

        if (value.length < 8 || value.length > 16) {
            setPasswordMessage('⚠️ 비밀번호는 8자 이상 16자 이하로 입력해주세요.');
        } else {
            setPasswordMessage('');
        }

        // 비밀번호가 변경되면 재입력 메시지 업데이트
        if (value === confirmPassword) {
            setConfirmPasswordMessage('');
        } else {
            setConfirmPasswordMessage('비밀번호가 일치하지 않습니다.');
        }
    };

    // 비밀번호 재입력 변경 핸들러
    const handleConfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);

        if (password === value) {
            setConfirmPasswordMessage('');
        } else {
            setConfirmPasswordMessage('비밀번호가 일치하지 않습니다.');
        }
    };

    return (
        <>
            <InputSection>
                <Label htmlFor="password">비밀번호</Label>
                <Input
                    type="password"
                    id="password"
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="8~16자 입력"
                />
                {passwordMessage && <Message isError={passwordMessage.startsWith('⚠️')}>{passwordMessage}</Message>}
            </InputSection>

            <InputSection>
                <Label htmlFor="confirmPassword">비밀번호 확인</Label>
                <Input
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={handleConfirmPasswordChange}
                    placeholder="비밀번호 재입력"
                />
                {password && confirmPassword && (
                    <Message isError={password !== confirmPassword}>{confirmPasswordMessage}</Message>
                )}
            </InputSection>
        </>
    );
};

export default PasswordInputSection;
